import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";
import {genericListboxFetch} from "root/ReactHookForm/ui/DropdownDataProviders";

export const getTeamDetails = (team_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/'+team_id ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const createTeam = (formData, organisation_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team?organisation_id=' + organisation_id ;

    getDataWithPromise(url, 'POST', { formData: formData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const updateTeam = (team_id, postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/' + team_id ;

    getDataWithPromise(url, 'POST', { formData: postFormData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const deleteTeam = (team_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/' + team_id ;

    getDataWithPromise(url, 'DELETE', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getMyTeams = (enc_user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/user/' + enc_user_id + '/teams?application=arcom' ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const getTeamMembers = (team_id, type, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/' + team_id + '/members?type=' + type;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const getUsersConnectedToChildrenInTeam = (team_id, user_type, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/' + team_id + '/connectedUsers?type=' + user_type ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const addUsersToTeam = (team_id, postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/' + team_id + '/users';

    getDataWithPromise(url, 'post', {formData: postFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const removeUserFromTeam = (team_id, user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/team/' + team_id + '/users/' + user_id ;

    getDataWithPromise(url, 'delete', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}
